<!-- HOME PAGE -->
<div class="container">
  <!-- HEADER PAGE -->

  <!-- ROW TITLE -->
  <div fxLayout="row wrap" fxLayoutAlign="center">
    <div fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <!-- TITLE -->
      <div class="title alicent">
        Choose your price
      </div>
    </div>

  </div>

  <div fxLayout="row wrap" fxLayoutAlign="center">
    <div fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="40" fxFlex.sm="40" fxFlex.xs="90">

      <!-- WARNING -->
      <div class="paragraph alicent">
        The Pricing simulation that follows provides estimations based on your expected study needs and is not contractually binding. You will 
        be able to save your simulation in pdf for reference or send it directly to us for validation.
      </div>

      <div class="subtitle alicent">
        You are:
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <mat-radio-group class="radio-gp" [(ngModel)]="orgType">
          <mat-radio-button class="radio-btn" value="2">Commercial law company</mat-radio-button>
          <mat-radio-button class="radio-btn" value="1">Non-profit organization<br><small>Start quote</small></mat-radio-button>
          <mat-radio-button class="radio-btn" value="3">Non-profit organization<br><small>Research partnership agreement application</small></mat-radio-button>
        </mat-radio-group>
      </div>

        <div class="btncontainer buttons">
          <button mat-flat-button class="btn-start-hover color-3" [disabled]="orgType != null ? false : true" (click)="startPricing()">
            Start
          </button>
        </div>
      </div>
    </div>


    <app-footer></app-footer>